module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Yesterday I was clever, so I wanted to change the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Today I am wise, so I am changing myself.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("—")]), _vm._v("R"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("UMI")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Monday, Monday. Can’t trust that day.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("—")]), _vm._v("T"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("HE ")]), _vm._v("M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AMAS")]), _vm._v(" & "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("THE ")]), _vm._v("P"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("APAS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0